<template>
    <modal name="monthlyPayment"
           @before-open="beforeOpen"
           :width="defaultOptions.width"
           :min-width="defaultOptions.minWidth"
           :max-width="defaultOptions.maxWidth"
           :height="defaultOptions.height"
           :adaptive="defaultOptions.adaptive"
    >

        <div class="cabinet-modal">
            <button class="cabinet-modal__close-modal" v-on:click="$modal.hide('monthlyPayment')">
                <svg width="16px" height="16px" enable-background="new 0 0 371.23 371.23" version="1.1" viewBox="0 0 371.23 371.23" xml:space="preserve" xmlns="http://www.w3.org/2000/svg">
                <polygon class="modal-close" points="371.23 21.213 350.02 0 185.62 164.4 21.213 0 0 21.213 164.4 185.62 0 350.02 21.213 371.23 185.62 206.83 350.02 371.23 371.23 350.02 206.83 185.62"/>
                </svg>
            </button>
            <section class="cabinet-modal__header">
                <h3 class="cabinet-modal__header-title">Ежемесячный платеж</h3>
            </section>
            <section class="cabinet-modal__body">
                <div class="cabinet-modal__col-1-1">
                    <div class="cabinet-modal__content-info">
                        <div class="cabinet-modal__content-title">Сумма к оплате</div>
                        <div class="cabinet-modal__content-text">{{amountToPay | ceil | numberFormat}} ₸</div>
                    </div>
                    <div class="cabinet-modal__content-info">
                        <div class="cabinet-modal__content-title">Внесено ранее</div>
                        <div class="cabinet-modal__content-text">{{balance | ceil | numberFormat}} ₸</div>
                    </div>
                    <div class="cabinet-modal__input-wrap">
                        <c-input
                                :label="'Сумма платежа'"
                                :type="'tel'"
                                :fieldName="'monthlyPayment'"
                                :validation="'decimal'"
                                :externalStatus="externalStatus"
                                v-model="paymentSum"
                                @click.native="closeTooltip"
                                @focusout.native="inputFocusOut"
                        >
                            <template slot="hint"></template>
                            <template slot="tooltip">
                                <c-tooltip v-if="showTooltip" :position="'right-bottom'" :maxWidth="260" :top="35" :right="10">Сумму платежа можно изменить</c-tooltip>
                            </template>
                        </c-input>
                    </div>
                </div>
            </section>
            <section class="cabinet-modal__button-wrap">
                <button :disabled="!showPaymentButton" v-on:click="paymentClick" class="button button--yellow button--full button--form">Погасить с карты</button>
            </section>
        </div>
    </modal>
</template>

<script>
    import widthMixin from '@/modules/mixins/widthMixin'
    import {STATUSES} from "@/components/statuses";

    export default {
        name: 'PaymentPopup',
        mixins: [widthMixin],
        data() {
            return {
                defaultOptions: {
                    adaptive: true,
                    minWidth: 320,
                    maxWidth: 360,
                    width: '100%',
                    height: 315
                },
                externalStatus: STATUSES.COMPLETE,
                amountToPay: 0,
                amountOfPayment: 0,
                balance: 0,
                paymentSum: 0,


                showTooltip: true,
                showPaymentButton: false,
            }
        },
        watch: {
            paymentSum: function (newVal, oldVal) {
                this.showPaymentButton = this.paymentSum.replace(/[^0-9.]/g, "") > 0;
                if(oldVal !== newVal){
                    if(newVal.indexOf('₸') > 0){

                    }else{
                       this.paymentSum = newVal.toString().replace(/[^0-9.]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, " ");
                    }

                }
            },
        },
        computed: {
            currentLoan: function () {
                return this.$store.getters['current/getCurrentLoan']
            }
        },
        methods: {
            paymentClick: function() {
                let data = new URLSearchParams();
                data.append('creditId', this.currentLoan.documentNumber);
                data.append('amount', this.paymentSum.replace(/[^0-9.]/g, ""));
                this.$http.post('/json/payment/processing-kz/simple-payment', data).then(
                    (response) => {
                        if (response.data.code === 300) {
                            window.location.replace(response.data.redirect.value);
                        }
                    },
                    (response) => {

                    }
                )
            },
            inputFocusOut: function(){
                this.paymentSum = this.paymentSum.toString().replace(/[^0-9.]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, " ") + ' ₸'
            },
            closeTooltip: function(){
                 this.showTooltip = false;
                 this.paymentSum = this.paymentSum.toString().replace(/[^0-9.]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, " ");
            },
            beforeOpen(event) {
                this.amountToPay = event.params.amountToPay;
                this.amountOfPayment = event.params.amountOfPayment;
                this.balance = event.params.balance;
            }
        },
        mounted: {
        }

    }
</script>

<style lang="scss">
    @import "~@/assets/scss/variable";

    .cabinet-modal {
        position: relative;
        display: flex;
        flex-direction: column;
        max-height: 100%;
        height: 100%;
        &__header {
            margin: 0 10px 0;
            padding: 10px 0;
            max-width: calc(100% - 20px);
            width: 100%;
            border-bottom: 1px solid #DCDCDC;
        }
        &__header-title {
            color: #333333;
            font-family: $RobotoMedium;
            text-align: center;
            font-weight: normal;
            font-size: 18px;
        }
        &__close-modal {
            right: 5px;
            top: 5px;
            z-index: 2000;
            background: none;
            border: none;
            display: inline-block;
            position: absolute;
            padding: 10px;
            box-sizing: border-box;
            border-radius: 50%;
            transition: background-color 0.3s ease;
            svg {
                display: block;
            }
            .modal-close {
                width: 22px;
                height: 22px;
                fill: $purple-site;

            }
            &:hover {
                transition: background-color 0.3s ease;
                background: #F0F0F0;;
                cursor: pointer;
                .modal-close {
                    fill: $purple-site;
                }
            }
        }
        &__body {
            padding: 10px 5px;
            flex: 1;
        }
        &__content-info {
            max-width: 100%;
            margin: 5px 10px;
            display: flex;
            justify-content: space-between;
            padding: 10px 10px;
            background-color: rgba(240, 240, 240, 0.5);
        }
        &__info-content {
        }
        &__input-wrap{
            margin-top: 20px;
            & .c-form-wrap.c-form-wrap--complete .c-form-wrap__input {
                font-size: 16px;
            }
        }
        &__button-wrap{
            text-align: center;
            margin: 0px 15px 30px;
        }
    }

</style>